import { Component, Input, OnChanges, SimpleChanges, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';

import { findIndex, isEmpty } from 'lodash';

import { environment } from '../../../environments/environment';
import { IDuplicateBy } from '../../interfaces/duplicate-by.interface';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'steps-errors',
  templateUrl: './steps-errors.component.html',
  styleUrls: ['./step.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class StepsErrorsComponent implements OnChanges {
  stepsErrors;
  public isArray = Array.isArray;

  @Input() fieldsInvalid;
  @Input() fieldsDescription;
  @Input() backendError;
  @Input() duplicationError: IDuplicateBy;

  get hasDuplicates(): boolean {
    return (
      this.duplicationError &&
      (Boolean(this.duplicationError.email) || Boolean(this.duplicationError.emp_no) || Boolean(this.duplicationError.personnel_number) || Boolean(this.duplicationError.phone))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.fieldsInvalid) {
      this.makeStepsErrors();
    }

    if (changes && changes.fieldsDescription) {
      this.makeStepsErrors();
    }
  }

  makeStepsErrors() {
    const invalidFieldsDescription = {};

    this.stepsErrors = null;

    if (!this.fieldsInvalid || !this.fieldsDescription) {
      return;
    }

    this.fieldsInvalid.forEach((fieldName) => {
      if (!environment.production && !this.fieldsDescription[fieldName]) {
        console.log('В описании ошибок нет поля ' + fieldName);
      }
      const step = this.fieldsDescription[fieldName]['step'];
      const stepKey = 'step' + step;
      const sectionName = this.fieldsDescription[fieldName]['sectionName'];
      const subSectionName = this.fieldsDescription[fieldName]['subSectionName'];
      const fdName = this.fieldsDescription[fieldName]['fieldName'];
      let sectionsIndex = null;
      let subSectionsIndex = null;

      if (!invalidFieldsDescription[stepKey]) {
        invalidFieldsDescription[stepKey] = {
          stepName: 'Шаг ' + step,
          sections: [],
        };
      }

      sectionsIndex = findIndex(invalidFieldsDescription[stepKey]['sections'], {
        sectionName: sectionName,
      });

      if (sectionsIndex === -1) {
        invalidFieldsDescription[stepKey]['sections'].push({
          sectionName: sectionName,
          fields: [],
          subSections: [],
        });

        sectionsIndex = findIndex(invalidFieldsDescription[stepKey]['sections'], {
          sectionName: sectionName,
        });
      }

      if (subSectionName) {
        subSectionsIndex = findIndex(invalidFieldsDescription[stepKey]['sections'][sectionsIndex]['subSections'], {
          subSectionName: subSectionName,
        });

        if (subSectionsIndex === -1) {
          invalidFieldsDescription[stepKey]['sections'][sectionsIndex]['subSections'].push({
            subSectionName: subSectionName,
            fields: [],
          });

          subSectionsIndex = findIndex(invalidFieldsDescription[stepKey]['sections'][sectionsIndex]['subSections'], {
            subSectionName: subSectionName,
          });
        }
      }

      if (subSectionName) {
        invalidFieldsDescription[stepKey]['sections'][sectionsIndex]['subSections'][subSectionsIndex]['fields'].push(fdName);
      } else {
        invalidFieldsDescription[stepKey]['sections'][sectionsIndex]['fields'].push(fdName);
      }
    });

    this.stepsErrors = !isEmpty(invalidFieldsDescription) ? invalidFieldsDescription : null;
  }
}

// fieldsInvalid = ['someName1', 'someName2']
// stepsErrors = {
//   step1: {
//     stepName: 'Шаг 1',
//     sections: [
//       {
//         sectionName: 'Основная информация',
//         fields: ['Форма юр. лица', 'Наименование'],
//       },
//       {
//         sectionName: 'Адреса',
//         fields: [],
//         subSections: [
//           {
//             subSectionName: 'Юридический',
//             fields: ['Область', 'Город']
//           }
//         ]
//       }
//     ]
//   }
// }
